// extracted by mini-css-extract-plugin
export default {"wrapper":"spinner_wrapper__DMBOP","spinner":"spinner_spinner__9Uj+a","spin":"spinner_spin__oOyLt"};